
import React, { FC, useState } from "react";
import Button from "../../../components/common/form/Button";
import { useGetEnumsQuery } from "../../../app/globalApi";
import Modal from "../../../components/common/form/Modal";
import { useComputeOrderStatusMutation, useUpdateProductsStatusMutation } from "../ordersApi";
import Form from "../../../components/common/form/Form"
import SelectField from "../../../components/common/form/SelectField";
import { createOptionListForSelectTag } from "../../../helpers/utils/Utils";
import InputField from "../../../components/common/form/InputField";

interface UpdateStatusModalProps {
    show: boolean;
    setShow: React.Dispatch<React.SetStateAction<boolean>>;
    orderData: any;
}

const UpdateStatusModal: FC<UpdateStatusModalProps> = ({
    show,
    setShow,
    orderData,
}) => {

    const [orderStatus, setOrderStatus] = useState<string | null>(orderData?.orderStatus || null);
    const [shouldFlushResults, setShouldFlushResults] = useState<string[]>([]);
    const [productsList, setProductList] = useState<any[]>(orderData?.products || []);
    const [indexList, setIndexList] = useState<string[]>([]);
    const { data: enums } = useGetEnumsQuery("");
    const [computeOrderStatus] = useComputeOrderStatusMutation();
    const [updateProductsStatus, { isLoading }] = useUpdateProductsStatusMutation();

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        await updateProductsStatus({
            products: productsList,
            shouldFlushResults: shouldFlushResults,
        }).unwrap();
        setShow(false);
    };

    return (

        <>

            {orderData &&
                <Modal title={"Order Status"} show={show} setShow={setShow} className={"w-2/5"}
                    fields={
                        <Form onSubmit={handleSubmit} fields={
                            <>
                                <div className="modal-body">
                                    {productsList.map((product: any) => (
                                        <>
                                            <SelectField
                                                label={enums?.["ProductType"].find((p: any) => p.constant === product.type)?.value}
                                                labelPosition="right"
                                                placeholder={"Select Product Status"}
                                                value={{
                                                    label: enums?.["ProductStatus"].find((enumVal: any) => enumVal.constant === product.productStatus)?.value,
                                                    value: product.productStatus
                                                }}
                                                options={createOptionListForSelectTag(enums?.["ProductStatus"], "value", "constant")}
                                                onChange={async (e: any) => {
                                                    const updatedList = productsList.map((p) =>
                                                        p.id === product?.id ? { ...p, productStatus: e?.value } : p
                                                    );
                                                    setProductList(updatedList);
                                                    setIndexList(prev => [...new Set([...prev, product.id])]);
                                                    setShouldFlushResults(prev => [...new Set([...prev, product.id])]);
                                                    await computeOrderStatus(updatedList)
                                                        .unwrap()
                                                        .then((status: any) => setOrderStatus(status));
                                                }}
                                                required={true}
                                                hideClearIcon={true}

                                            />

                                            {(orderStatus === 'NEW' || orderStatus === 'PENDING') && indexList.includes(product.id) && (
                                                <>
                                                    <div className="col-span-12 grid grid-cols-12 gap-3 mb-2 mt-2">
                                                        <div className='col-span-3'></div>
                                                        <div className='col-span-9 flex'>
                                                            <input
                                                                checked={shouldFlushResults.includes(product.id)}
                                                                type="checkbox"
                                                                onClick={() => {
                                                                    setShouldFlushResults((prev) => {
                                                                        if (prev.includes(product.id)) {
                                                                            return prev.filter(id => id !== product.id);
                                                                        } else {
                                                                            return [...prev, product.id];
                                                                        }
                                                                    });
                                                                }}
                                                            />
                                                            <p className="m-0 ml-2 text-[red]">
                                                                Clear editor values for {enums?.["ProductType"].find((p: any) => p.constant === product.type)?.value}
                                                            </p>
                                                        </div>
                                                    </div>

                                                </>
                                            )}


                                        </>
                                    ))}


                                    <InputField
                                        label="Order Status"
                                        value={enums?.["OrderStatus"].find((enumVal: any) => enumVal.constant === orderStatus)?.value}
                                        type="text"
                                        placeholder="Enter Order Status..."
                                        required={true}
                                        disabled={true}
                                    />
                                </div>

                                <div
                                    className="flex justify-end gap-2 border-t  pt-4 mt-4 border-surface-3">
                                    <Button btnText={"Close"} isLoading={false} type={"close"}
                                        onClick={() => setShow(false)} />
                                    <Button btnText={"Submit"} isLoading={isLoading} type={"submit"}></Button>
                                </div>
                            </>
                        } />
                    } />
            }
        </>

    );
};

export default UpdateStatusModal;
